<template>
    <div class="counters">
        <span class="sub">{{ hasScore ? this.aggregateScore : '-' }}</span>
        <span class="main">{{ hasScore ? fixture.score.total_score_home : '-'}} : {{ hasScore ? fixture.score.total_score_away : '-'}}</span>
        <span class="sub">{{ hasScore ? fixture.score.half_time_score_home : '-'}} : {{ hasScore ? fixture.score.half_time_score_away : '-'}}</span>
    </div>
</template>

<script>
    let interval = null;

    import axios from 'axios'
    export default {
        props: ['fixture_id'],
        data() {
            return {
                isLoading: false,
                fixture: null,
                timer: 0,
                timerOn: true
            }
        },
        computed: {
            hasScore: function () {
                if (this.fixture === null) {
                    return false;
                }

                return (typeof this.fixture.score !== 'undefined');
            },
            aggregateScore: function () {
                if (this.fixture.score.aggregate_score_home !== undefined && this.fixture.score.aggregate_score_away !== undefined) {
                    return this.fixture.score.aggregate_score_home + ' : ' + this.fixture.score.aggregate_score_away + ' agg';
                }
                return '';
            }
        },
        mounted() {
            this.loadFixture();

            interval = setInterval(() => {
                this.timerTick();
            }, 1000);
        },
        methods: {
            timerTick() {
                if (this.timerOn) {
                    this.timer += 1;
                    // loading new fixture data every 45 seconds, to grab current score
                    if (this.timer >= 45) {
                        this.loadFixture();
                    }
                }
            },
            loadFixture() {
                this.timerOn = false; // stop the timer until we get a response
                this.timer = 0; // reset it so that after we get a response, we'll start counting to 45 again.

                axios.get('/api/fixture/' + this.fixture_id).then((response) => {
                    this.fixture = response.data;
                    if (this.fixture.status === "played") {
                        this.timerOn = false;
                        clearInterval(interval); // clear the timer interval
                    } else {
                        this.timerOn = true;
                    }
                }).catch(() => {
                    this.timerOn = true; // continue the timer so that we can try again in 45 secs
                });
            }
        }
    }
</script>
